import { Container } from './styles';

function Button({ children, loading, ...rest }){
  return(
    <Container type="button" {...rest}>
      {loading ? 'Carregando ...' : children}
    </Container>
  )
};

export default Button;
